import { autoinject } from 'aurelia-framework';
import { Models } from 'models/core';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class LocationCodeService extends BaseApiService<Models.LocationCode> {
    constructor(httpClient: AuthHttpClient) {
        super(httpClient, Models.LocationCode); 
    }

    public getByServiceStation(serviceStationId: number): Promise<Array<Models.LocationCode>> {
        if (!serviceStationId) {
            return Promise.resolve([]);
        }

        return this.getAll(`?$filter=ServiceStationId eq ${serviceStationId}`);
    }
}